import { B as r } from "../separate-component-helper-chunks/chart-base-DQP-2wFc.js";
import { C as e } from "../separate-component-helper-chunks/chart-area-BsgrZ-u1.js";
import { E as o } from "../separate-component-helper-chunks/exporting-DYdg9_uB.js";
import { N as m } from "../separate-component-helper-chunks/navigator-EfJ3IK8B.js";
import { m as i } from "../separate-component-helper-chunks/mixin-DsSIi_3b.js";
const a = {
  beaconTagName: "beacon-line-chart"
}, t = class t extends i(r).with(
  e,
  m,
  o
) {
  constructor() {
    super(...arguments), this.beaconTagName = a.beaconTagName;
  }
  static get styles() {
    return [super.styles, this.chartAreaStyles, this.navigatorStyles];
  }
};
t.tagName = a.beaconTagName;
let s = t;
export {
  s as BeaconLineChart
};
